import { z } from 'zod'

export const loginFormSchema = z.object({
  email: z.string().min(1, 'Obrigatório').email('E-mail inválido'),
  password: z.string().min(1, 'Obrigatório'),
})

export type LoginFormData = z.infer<typeof loginFormSchema>
